import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  TextField,
  MenuItem,
  IconButton,
  Typography,
  Select,
} from "@mui/material";

import {
  Visibility,
  Delete,
  NotificationsActive,
  WhatsApp,
  Email,
  Sms,
} from "@mui/icons-material";
import Edit from "@mui/icons-material/Edit";

import { useNavigate } from "react-router-dom";
import deleteConfirm from "./deleteEmp";

const API_URL = "https://api.hr-ebnhaian.cloud/api/v1/employees";

function App() {
  const [employees, setEmployees] = useState([]);
  const [statusFilter, setStatusFilter] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const navigate = useNavigate();

  /* =========================
     FETCH EMPLOYEES
  ========================= */
  const fetchEmployees = () => {
    axios
      .get(API_URL, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        setEmployees(res.data.data || []);
      })
      .catch((err) => {
        console.error("Error fetching employees:", err);
      });
  };

  useEffect(() => {
    fetchEmployees();
  }, []);

  /* =========================
     FILTER
  ========================= */
  const filteredEmployees = employees.filter((emp) => {
    const name = `${emp.firstName} ${emp.lastName}`.toLowerCase();
    const email = (emp.email || "").toLowerCase();

    return (
      (!statusFilter || emp.status === statusFilter) &&
      (name.includes(searchTerm.toLowerCase()) ||
        email.includes(searchTerm.toLowerCase()))
    );
  });

  return (
    <Box p={3}>
      <Typography variant="h5" mb={2}>
        Employees
      </Typography>

      {/* ACTION BAR */}
      <Box display="flex" alignItems="center" gap={2} mb={2}>
        <Button variant="contained" startIcon={<Email />}>
          Send Email
        </Button>
        <Button variant="contained" color="warning" startIcon={<Sms />}>
          Send SMS
        </Button>
        <Button variant="contained" color="success" startIcon={<WhatsApp />}>
          Send WhatsApp
        </Button>

        <Select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          displayEmpty
          size="small"
        >
          <MenuItem value="">All Status</MenuItem>
          <MenuItem value="ACTIVE">Active</MenuItem>
          <MenuItem value="INACTIVE">Inactive</MenuItem>
        </Select>

        <TextField
          size="small"
          label="Search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </Box>

      {/* TABLE */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead sx={{ backgroundColor: "#1976d2" }}>
            <TableRow>
              <TableCell sx={{ color: "white" }}>
                <input type="checkbox" />
              </TableCell>
              <TableCell sx={{ color: "white" }}>Photo</TableCell>
              <TableCell sx={{ color: "white" }}>Alert</TableCell>
              <TableCell sx={{ color: "white" }}>Name</TableCell>
              <TableCell sx={{ color: "white" }}>Email</TableCell>
              <TableCell sx={{ color: "white" }}>Branch</TableCell>
              <TableCell sx={{ color: "white" }}>Code</TableCell>
              <TableCell sx={{ color: "white" }}>Loginname</TableCell>
              <TableCell sx={{ color: "white" }}>Department</TableCell>
              <TableCell sx={{ color: "white" }}>Designation</TableCell>
              <TableCell sx={{ color: "white" }}>Status</TableCell>
              <TableCell sx={{ color: "white" }}>Log</TableCell>
              <TableCell sx={{ color: "white" }}>Details</TableCell>
              <TableCell sx={{ color: "white" }}>Edit</TableCell>
              <TableCell sx={{ color: "white" }}>Delete</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {filteredEmployees.map((emp) => (
              <TableRow key={emp._id}>
                {/* Check */}
                <TableCell>
                  <input type="checkbox" />
                </TableCell>

                {/* Photo */}
                <TableCell>
                  <Avatar
                    sx={{ width: 60, height: 60 }}
                    src={
                      emp.profileImage
                        ? `https://api.hr-ebnhaian.cloud/uploads/employees/profiles/${emp.profileImage}`
                        : undefined
                    }
                  >
                    {!emp.profileImage && emp.firstName?.charAt(0)}
                  </Avatar>
                </TableCell>

                {/* Alert */}
                <TableCell>
                  <NotificationsActive color="warning" />
                </TableCell>

                {/* Name */}
                <TableCell>
                  {emp.firstName} {emp.lastName}
                </TableCell>

                {/* Email */}
                <TableCell>{emp.email || "-"}</TableCell>

                {/* Branch */}
                <TableCell>{emp.center?.name || "-"}</TableCell>

                {/* Code */}
                <TableCell>{emp.employeeCode}</TableCell>

                {/* Loginname */}
                <TableCell>{emp.email || "-"}</TableCell>

                {/* Department */}
                <TableCell>{emp.jobRole}</TableCell>

                {/* Designation */}
                <TableCell>{emp.jobTitle}</TableCell>

                {/* Status */}
                <TableCell>
                  <Button
                    size="small"
                    variant="contained"
                    color={emp.status === "ACTIVE" ? "success" : "error"}
                  >
                    {emp.status === "ACTIVE" ? "Active" : "Inactive"}
                  </Button>
                </TableCell>

                {/* Log */}
                <TableCell>
                  <IconButton>
                    <Visibility />
                  </IconButton>
                </TableCell>

                {/* Details */}
                <TableCell>
                  <IconButton onClick={() => navigate(`/employees/${emp._id}`)}>
                    📁
                  </IconButton>
                </TableCell>

                {/* Edit */}
                <TableCell>
                  <IconButton
                    color="primary"
                    onClick={() => navigate(`/employees/${emp._id}/edit`)}
                  >
                    <Edit />
                  </IconButton>
                </TableCell>

                {/* Delete */}
                <TableCell>
                  <IconButton
                    color="error"
                    onClick={() =>
                      deleteConfirm(`${API_URL}/${emp._id}`, fetchEmployees)
                    }
                  >
                    <Delete />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}

            {filteredEmployees.length === 0 && (
              <TableRow>
                <TableCell colSpan={15} align="center">
                  No employees found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default App;
